
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormComponent } from './components/form.component';
import { AuthGuard } from './guards/auth.guard';
import { ErrorComponent } from './components/error.component';
import { FormResolver } from './components/form.resolver';
import { SuccessComponent } from './components/success.component';

const routes: Routes = [
  { path: 'transactions/:hash', component: FormComponent, canActivate: [AuthGuard], resolve: {data: FormResolver} },
  { path: 'success', component: SuccessComponent },
  {path: '400', component: ErrorComponent, data: {code: '400'}},
  {path: '404', component: ErrorComponent, data: {code: '404'}},
  {path: '204', component: ErrorComponent, data: {code: '204'}},
  {path: '410', component: ErrorComponent, data: {code: '410'}},
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
